module.exports = __webpack_public_path__ + "static/img/QX_H5.0acddaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/QX_H5.png
// module id = ypwu
// module chunks = 34